<template>
    <div>
      <trademark-search-status-list></trademark-search-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  